module.exports = __webpack_public_path__ + "static/fontawesome-webfont.woff";